module.exports = __webpack_public_path__ + "static/img/Scorpio.7e20eb2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/horoscope_icon/Scorpio.svg
// module id = 375
// module chunks = 0